import { FC } from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from 'recharts';
import { ChartEmptyState } from '../../AthleteInjuryCharts/charts/_shared/ChartEmptyState';
import { ITeamMonthlyRateMetric } from '../../../../models/injury';
import {
  chartAxisTick,
  chartGridProps,
  chartTooltipContentStyle,
  chartTooltipItemStyle,
  chartTooltipLabelStyle,
} from '../../../../shared/charts/chartTheme';

interface Props {
  data: ITeamMonthlyRateMetric | null;
}

export const TeamMonthlyRateChart: FC<Props> = ({ data }) => {
  if (!data?.data?.length) return <ChartEmptyState />;

  const chartData = data.data.map((d) => ({
    month: d.month.slice(5) + '/' + d.month.slice(2, 4),
    count: d.count,
  }));

  return (
    <ResponsiveContainer width="100%" height={200}>
      <BarChart data={chartData} margin={{ top: 4, right: 8, left: -20, bottom: 0 }}>
        <CartesianGrid {...chartGridProps} />
        <XAxis dataKey="month" tick={chartAxisTick} />
        <YAxis tick={chartAxisTick} allowDecimals={false} />
        <Tooltip
          contentStyle={chartTooltipContentStyle}
          labelStyle={chartTooltipLabelStyle}
          itemStyle={chartTooltipItemStyle}
          formatter={(v) => [v, 'Infortuni']}
        />
        <Bar dataKey="count" fill="var(--c-text-0)" radius={[4, 4, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
};
